const LIGHT_MODE = "light-mode";
const DARK_MODE = "dark-mode";

const VISITOR_THEME_MODES = [LIGHT_MODE, DARK_MODE];

const PREFERS_DARK_QUERY = "(prefers-color-scheme: dark)";

function isVisitorThemeMode(themeMode) {
  return VISITOR_THEME_MODES.includes(themeMode);
}

function visitorThemeMode(prefersDark) {
  return prefersDark === true ? DARK_MODE : LIGHT_MODE;
}

function prefersDarkMediaQuery() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return null;
  }
  return window.matchMedia(PREFERS_DARK_QUERY);
}

function readVisitorThemeMode() {
  return visitorThemeMode(prefersDarkMediaQuery()?.matches === true);
}

function subscribeToVisitorThemeMode(onChange) {
  const mediaQuery = prefersDarkMediaQuery();
  if (mediaQuery === null) {
    return () => {};
  }
  let lastReported = visitorThemeMode(mediaQuery.matches === true);
  const report = () => {
    const mode = visitorThemeMode(mediaQuery.matches === true);
    if (mode === lastReported) {
      return;
    }
    lastReported = mode;
    onChange(mode);
  };
  mediaQuery.addEventListener("change", report);
  return () => mediaQuery.removeEventListener("change", report);
}

module.exports = {
  DARK_MODE,
  LIGHT_MODE,
  VISITOR_THEME_MODES,
  isVisitorThemeMode,
  readVisitorThemeMode,
  subscribeToVisitorThemeMode,
  visitorThemeMode,
};
